import React from 'react';
// import type { WheelMenuItem } from '@/types'; // Removed assumption

// Define type locally for now
export interface WheelMenuItem {
  id: string;
  label: string; // Keep label for tooltip/accessibility
  icon: React.ReactNode; // Icon is now mandatory
  action: () => void; 
}

interface WheelMenuProps {
  isVisible: boolean;
  position: { x: number; y: number };
  items: WheelMenuItem[];
  onClose: () => void; 
  onItemActivate: (item: WheelMenuItem) => void; 
}

const WheelMenu: React.FC<WheelMenuProps> = ({ isVisible, position, items, onClose, onItemActivate }) => {
  const radius = 100; 
  const itemSize = 40; 

  if (!isVisible) {
    return null;
  }

  const handleItemClick = (item: WheelMenuItem) => {
    if (item.id !== 'add-new') { 
        item.action();
    }
    onItemActivate(item); 
  };

  const getItemStyle = (index: number): React.CSSProperties => {
    const angle = (index / items.length) * 2 * Math.PI - Math.PI / 2; 
    const x = radius * Math.cos(angle);
    const y = radius * Math.sin(angle);
    return {
      position: 'absolute',
      left: `calc(50% + ${x}px - ${itemSize / 2}px)`,
      top: `calc(50% + ${y}px - ${itemSize / 2}px)`,
      width: `${itemSize}px`,
      height: `${itemSize}px`,
      transition: 'transform 0.2s ease-out, background-color 0.2s ease-out',
    };
  };

  return (
    <div
      className="wheel-menu-container fixed z-50 flex items-center justify-center pointer-events-none" 
      style={{
        left: `${position.x}px`,
        top: `${position.y}px`,
        width: '1px', 
        height: '1px',
        transform: 'translate(-50%, -50%)', 
      }}
    >
        {/* Background Circle */}
        <div 
          className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full bg-gray-800/80 backdrop-blur-sm shadow-xl border border-gray-700 pointer-events-auto" 
          style={{ width: `${radius * 2 + 20}px`, height: `${radius * 2 + 20}px` }}
        ></div>

        {/* Invisible center point - items are positioned relative to this */}
        <div className="relative pointer-events-none" style={{ width: `${radius * 2}px`, height: `${radius * 2}px`}}>
             {items.map((item, index) => (
                <button
                    key={item.id}
                    onClick={() => handleItemClick(item)} 
                    style={getItemStyle(index)}
                    className={`pointer-events-auto flex items-center justify-center rounded-full bg-primary text-primary-foreground shadow-lg hover:bg-primary/90 hover:scale-110 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 focus:ring-offset-background`}
                    title={item.label} 
                >
                    {item.icon} 
                </button>
             ))}
        </div>
    </div>
  );
};

export default WheelMenu; 